import { Input } from 'aos-ds'
import {
    translateParts,
    translatePartsOptional,
} from 'aos-helpers/src/helpers/translations/Translations'
import { toNumber, toText } from 'aos-ui-universal/src/components/number-input/parse'
import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { TaskFormField } from '../../TaskFormField'

interface TaskNumberFieldProps {
    keyPrefix: string
    value: number | undefined
    required?: boolean
    isError?: boolean
    max?: number
    seleniumLocation?: string
    className?: string
    onChange(value: number | undefined): void
}

export const TaskNumberField: FC<TaskNumberFieldProps> = ({
    keyPrefix,
    value,
    required,
    isError,
    max,
    seleniumLocation,
    className,
    onChange,
}) => {
    const { t } = useTranslation()
    const [text, setText] = useState(() => toText(value))

    return (
        <TaskFormField
            className={className}
            label={translateParts(t)(keyPrefix, 'label')}
            required={required}
            error={isError ? translatePartsOptional(t)(keyPrefix, 'error') : undefined}
            seleniumLocation={seleniumLocation}
        >
            <Input
                className='w-full'
                variant={isError ? 'error' : text ? 'filled' : 'not-filled'}
                keyboardType='numeric'
                value={text}
                placeholder={translatePartsOptional(t)(keyPrefix, 'placeholder')}
                onChangeText={next => {
                    const parsed = toNumber(next)
                    const clamped =
                        parsed !== undefined && max !== undefined ? Math.min(parsed, max) : parsed
                    setText(clamped !== parsed ? String(clamped) : next)
                    onChange(clamped)
                }}
            />
        </TaskFormField>
    )
}
